module.exports = __webpack_public_path__ + "img/layout-11_2.9af98538.png";